<template>
    <div class="row gx-3">
        <pc-input-group
            v-bind:class="responsiveHelpers.long"
            class="mb-0 d-flex align-items-baseline flex-wrap">
            <template v-if="templateName">
                <pc-label
                    v-bind:label="templateName"
                    v-bind:for-id="inputId"
                    class="me-2" />
                <pc-loader
                    v-bind:loading="generating"
                    small>
                    <pc-button
                        v-bind:id="inputId"
                        class="mx-2"
                        v-bind:disabled="readonly"
                        v-on:click="generate">
                        {{ generateDocumentButtonLabel }}
                    </pc-button>
                </pc-loader>
                <pc-help-icon
                    v-if="showHelp"
                    v-bind:help-link="showHelpLinkOnly"
                    v-on:click="emitHelpClicked" />
            </template>
            <div v-else>
                <span>
                    {{ templateNotConfigured }}
                </span>
                <span class="text-danger fw-bold">
                    {{ documentGenerationDisabled }}
                </span>
            </div>
        </pc-input-group>
        <div class="col-12 mb-3">
            <slot name="help" />
        </div>
    </div>
</template>

<script>
    import base from "./_elementBase";
    import {
        PROJECT_FORM_CONTROLLER_NAMESPACE,
        PROJECT_FORM_CONTROLLER_TYPES
    } from "../ProjectForm/projectFormControllerStore";
    import { isModuleRegistered } from "SharedStores/util";
    import { mapI18n } from "Util/i18n";
    import { KEYS, NAMESPACE } from "./i18n/documentGeneration.i18n";

    export default {
        extends: base,
        data() {
            return { generating: false };
        },
        computed: {
            templateName() {
                if (this.element.AuxiliaryModel) {
                    return this.element.AuxiliaryModel.TemplateName;
                }
                return null;
            },
            readonly() {
                return this.baseReadonly || this.isPrefill;
            },
            ...mapI18n(
                {
                    ...KEYS
                },
                NAMESPACE
            )
        },
        methods: {
            async generate() {
                if (
                    this.element.AuxiliaryModel &&
                    isModuleRegistered(PROJECT_FORM_CONTROLLER_NAMESPACE, this.$store.state)
                ) {
                    this.generating = true;
                    try {
                        await this.$store.dispatch(
                            PROJECT_FORM_CONTROLLER_TYPES.actions.generateDocument,
                            {
                                formElementId: this.element.PublicId,
                                templateDefinitionId: this.element.AuxiliaryModel.TemplateDefinitionId
                            },
                            { root: true }
                        );
                        // add an explicit delay to make sure that we don't allow click spam
                        await new Promise((resolve) => setTimeout(resolve, 500));
                    } finally {
                        // In admin page, user may reject promise to save and continue
                        this.generating = false;
                    }
                }
            }
        }
    };
</script>
